@if (control) {
  <div class="flex h-full w-full flex-col">
    <label [for]="name()">
      @if (!labelTemplate()) {
        @if (label()) {
          <span class="mb-2">{{ label() }}</span>
        }
      } @else {
        <div class="mb-2">
          <ng-container
            [ngTemplateOutlet]="labelTemplate()"
            [ngTemplateOutletContext]="{ $implicit: label() }" />
        </div>
      }
    </label>
    <div
      class="hover:bg-theme-gray-400 relative shrink-0 rounded border px-2 py-1"
      [ngClass]="{
        'border-theme-secondary-gray': !showError(),
        'border-error': showError(),
        '!bg-theme-gray-400 cursor-not-allowed opacity-60': disabled(),
        'bg-theme-gray-400 ring-error ring-1': isOpened() && showError(),
        'bg-theme-gray-400 ring-theme-secondary-gray ring-1': isOpened() && !showError(),
      }">
      <input
        #inputElement
        #datePickerDirective="dpDayPicker"
        class="text-theme-gray placeholder:text-theme-black text-md min-h-[24px] w-full min-w-[125px] border-none outline-none"
        [id]="name()"
        [ngClass]="{ 'pointer-events-none': disabled() || readonly() }"
        [formControl]="control"
        [dpDayPicker]="datePickerConfig"
        [placeholder]="placeholderText()"
        [isFocused]="isFocused()"
        (close)="closeEvent.emit(); isOpened.set(false)"
        (focus)="focusEvent.emit($event)"
        (open)="onDatePickerOpen(); isOpened.set(true)"
        (click)="clicked.emit()"
        (onSelect)="onSelect($event)" />
      <span
        class="pointer-events-none absolute top-0 right-2 bottom-0 flex items-center justify-center">
        <shared-core-material-icon name="calendar_today" style="color: #3b3b3b" />
      </span>
    </div>
    @if (showError()) {
      @for (error of validationErrors(); track error) {
        <span class="text-error">{{ error.message }}</span>
      }
    }
  </div>
}
